import { createQueryKeys } from "@lukemorales/query-key-factory";

/**
 * Query keys for services provider API calls
 *
 * To invalidate ALL servicesProviders queries, use: queries.servicesProviders._def
 */
export const servicesProviders = createQueryKeys('servicesProviders', {
  detail: (id: string) => [id],
  batch: (sortedIdsKey: string) => [sortedIdsKey],
  dmsConnection: (id: string) => ['dmsConnection', id],
});

